import React from 'react';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

/**
 * Les questions d'une nature de sinistre, posées en cascade.
 *
 * Une question conditionnée n'apparaît qu'une fois sa condition remplie :
 * l'assuré ne voit jamais trente causes d'un coup. Et chaque question porte
 * « je ne sais pas encore » — la cause d'une fuite encastrée n'est souvent
 * connue qu'après la recherche, et une cause inventée oriente vers la
 * mauvaise garantie.
 */
export default function Questionnaire({ questions, reponses, onReponse,
                                        desactive }) {
  const visible = (question) => {
    if (!question.depend_de) return true;
    return reponses[question.depend_de] === question.depend_de_reponse;
  };

  const posees = questions.filter(visible);
  if (!posees.length) return null;

  return (
    <Stack spacing={3}>
      {posees.map((question) => (
        <FormControl key={question.code} disabled={desactive}>
          <FormLabel sx={{ mb: question.aide ? 0.5 : 1 }}>
            <Typography variant="body1" component="span"
                        sx={{ fontWeight: 600 }}>
              {question.libelle}
            </Typography>
          </FormLabel>
          {question.aide && (
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
              {question.aide}
            </Typography>
          )}
          <RadioGroup
            value={reponses[question.code] ?? ''}
            onChange={(e) => onReponse(question.code, e.target.value)}
          >
            {question.reponses.map((r) => (
              <FormControlLabel
                key={r.code}
                value={r.code}
                control={<Radio size="small" />}
                label={
                  <Box component="span"
                       sx={{ color: r.inconnu ? 'text.secondary' : 'inherit',
                             fontStyle: r.inconnu ? 'italic' : 'normal' }}>
                    {r.libelle}
                  </Box>
                }
              />
            ))}
          </RadioGroup>
        </FormControl>
      ))}
    </Stack>
  );
}
